//js import
import 'swiper/css/bundle';
import Swiper from 'swiper/bundle';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
/**
 * Initialize the collaborations slider.
 * This function takes the collaborations slider and initializes
 * it by creating a new Swiper instance.
 * The options are as follows:
 *   - speed: 1000, the speed of the transition between slides.
 *   - spaceBetween: 16, the space between the slides.
 *   - slidesPerView: 1, the number of slides that are visible at the same time.
 *   - centeredSlides: true, whether the slides should be centered or not.
 *   - loop: false, whether the slider should loop or not.
 *   - freeMode: true, whether the slider should be in free mode or not.
 *   - navigation: an object with the next and prev buttons.
 *   - pagination: an object with the pagination element.
 * The function also sets up breakpoints for different screen sizes.
 * @since 1.0.0
 */
export function initializeCollaborationsSliders() {
    let collaborationsSlider = new Swiper('.collaborations__slider', {
        speed:1000,
        spaceBetween: 16,
        slidesPerView: 1,
        centeredSlides: true,
        loop: false,
        freeMode: true,
        navigation: {
            prevEl: ".collaborations__prev",
            nextEl: ".collaborations__next",
        },
        pagination: {
            el: ".collaborations__pagination",
            clickable:true
        },
        breakpoints: {
            // when the screen size is at least 576px wide
            576: {
                centeredSlides: false,
                slidesPerView: 2
            },
        }
    }); 
    lightGallery(document.getElementById('lightgallery-collaboration'), {
        plugins: [lgThumbnail],
        licenseKey: 'your_license_key',
        speed: 500,
        thumbnail: false,
        download: false,
        mobileSettings: {
            showCloseIcon: true,
            download: false
        },
    });
}

